import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { UserConnector } from '@core/user/user.connector';
import { getUser, getUserFail, getUserSuccess } from '@core/user/store/user.actions';
import { getCommerceStorageKeys } from '@shared/tools/storage-keys';

@Injectable()
export class UserEffects {
  constructor(
    private actions: Actions,
    private userConnector: UserConnector,
  ) {}

  getUser$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getUser),
      mergeMap(() => {
        const customerId = localStorage.getItem(getCommerceStorageKeys().customerId);
        if (!customerId) {
          return [getUserFail({ erroMessage: 'No customer ID available' })];
        }

        return this.userConnector.get(customerId).pipe(
          map(user => {
            if (user.hasError) {
              return getUserFail({ erroMessage: user.message || '' });
            }
            return getUserSuccess({ user });
          }),
        );
      }),
    );
  });
}
